<template>
  <main class="l-container">
    <slot name="body"></slot>

    <common-breadcrumb v-if="isBread" :heading="breadHeading" :breadcrumbType="'default'" />
  </main>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import IsMobile from '@/plugins/isMobile';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import CommonButton from '@/components/parts/button/CommonButton';
import CommonSelect from '@/components/parts/select/CommonSelect';


export default {
  name: 'CommonTemplate',
  mixins: [MixinAPI, IsMobile],
  props: ['title', 'isBread', 'breadHeading'],
  components: {
    CommonBreadcrumb,
    CommonButton,
    CommonSelect,
  },
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
// brake points 768px(tablet)/639px(sp)
@charset "UTF-8";

</style>
